/*
* Old C&L
*/
$(document).ready(function () {
    var latestVisitsList = $('.latest-visits-list');
    // Get the local storage item and parse it to JSON
    var latestVisitsArray = JSON.parse(localStorage.getItem('wlatestvisits'));
    var maxNumberOfItemsInList = 5;
    /********************************
     * Populate the list on the front page
     *********************************/
   
    if (latestVisitsArray != null && latestVisitsArray.length > 0) {
        // Populate latest visists list
        $(latestVisitsArray).each(function (i) {
            $(latestVisitsList)
                .append(
                '<li class="">' +
                '<a href="' + latestVisitsArray[i]["pageUrl"] + '">' +
                latestVisitsArray[i]["pageTitle"] +
                '</a>' +
                '</li>'
                );
        })
    } else {
        // If there are no items in the local storage
        $(latestVisitsList)
            .append(
            '<li class="no-favourites">You have not visited any pages yet.</li>'
            );
    }
   

    /********************************
     * Saving to the local storage list
     *********************************/

    // check if the location is contacts and locations (and not the front page of c&l)
    if (window.location.href.indexOf("contacts-and-locations/locations/") > -1 || window.location.href.indexOf("contacts-and-locations/contacts/") > -1) {
        // Get the page title of the page (and trim white space from start and end)
        var pageTitle = $('.cl-page-main-title').html().trim();
        if($('.type').length >0){
            var pageType = $('.type').html().trim();
            pageTitle = pageTitle + " (" + pageType + ")";
        }
        // Get page url
        var pageUrl = $(location).attr('href');

        // Check if the array has content
        if ($(latestVisitsArray).length > 0) {
            // If the visited page is in the array, remove it before adding it to the start of the array.
            latestVisitsArray = latestVisitsArray.filter(function (el) {
                return el.pageUrl !== pageUrl;
            });
           
            // add the page to the start of the array
            latestVisitsArray.unshift({ pageTitle:pageTitle, pageUrl:pageUrl });
            // Make sure there are not more than max num of items in the list. Remove from end of array.
            if($(latestVisitsArray).length > maxNumberOfItemsInList){
                latestVisitsArray.pop();
            }
            // Stringify and save the array to local storage
            localStorage.setItem("wlatestvisits", JSON.stringify(latestVisitsArray));
        } else {
            // The list has no content
            latestVisitsArray = [];
            // add the page to the start of the array
            latestVisitsArray.unshift({ pageTitle:pageTitle, pageUrl:pageUrl });
            // Stringify and save the array to local storage
            localStorage.setItem("wlatestvisits", JSON.stringify(latestVisitsArray));
        }
    }
});